"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ProtocolSelector_1 = require("./ProtocolTile/ProtocolSelector");
var HeadedTextareaInputContainer_1 = require("./HeadedTextareaInput/HeadedTextareaInputContainer");
var scrollToTop_1 = require("../../../../../utils/scrollToTop");
var wizardNavigationButtons_1 = require("../../wizardNavigationButtons");
var DebtType = function (props) {
    React.useEffect(function () {
        /**
         * When the protocol changes (switching debtor type between individual and business),
         * we want to ensure that validation runs on any fields that already have user input.
         *
         * However, to avoid showing error messages prematurely on empty fields,
         * we only mark fields as touched if they contain a value.
         *
         * This approach triggers validation only when the user has entered something —
         * preventing immediate error flashes on empty fields when switching protocol options.
         */
        if (props.values.goods_description) {
            props.setFieldTouched('goods_description', true, true);
        }
        if (props.values.services_description) {
            props.setFieldTouched('services_description', true, true);
        }
        if (props.values.representative_name) {
            props.setFieldTouched('representative_name', true, true);
        }
    }, [props.values.protocol_id]);
    (0, scrollToTop_1.default)();
    var debtTypeErrors = !!props.errors.representative_name || !!props.errors.goods_description || !!props.errors.services_description;
    return (React.createElement("div", { className: "add-debt-wizard-page flex-column" },
        React.createElement("div", { className: "add-debt-wizard-form-contents" },
            React.createElement("div", { className: "add-debt-wizard-form-description" },
                React.createElement("h2", null, "Debt Type"),
                React.createElement("p", null, "Select if your debt is owed by an individual or an organisation, and what you are owed for."),
                React.createElement("p", null, "There are a number of extra steps that must be taken when attempting to recover a debt from an individual. These mean that the debt may take longer to be recovered.")),
            React.createElement("div", { className: "form-panel" },
                React.createElement("label", { className: "required" }, "Please select the type of debtor by selecting if it\u2019s an individual or business."),
                React.createElement(ProtocolSelector_1.default, { values: props.values, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, validator: props.validator, BOEInterestRate: props.BOEInterestRate })),
            React.createElement("div", { className: "form-panel" },
                React.createElement("label", { className: "required" }, "Please describe the goods and/or services that you provided to the debtor."),
                React.createElement(HeadedTextareaInputContainer_1.default, { values: props.values, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched }))),
        React.createElement(wizardNavigationButtons_1.default, { previousPath: '/dashboard/debtwizard/page2', nextPath: '/dashboard/debtwizard/page4', disableNext: debtTypeErrors })));
};
exports.default = DebtType;
